<template>
  <v-container>
    <v-layout>
      <v-flex>
        <p>{{$tf('You have used all your storage free space If you want to continue uploading files, you will need a')}} {{$tf('Idonia Storage Subscription')}} {{$tf('or to delete some existing files')}}</p>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center>
        <v-btn class="accent white--text storage-plus" raised small>
          {{$tf('Get')}}<br/><img src="/static/images/storage+.png"/>
        </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'no-more-space',
    props: {
      interrupted: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    }
  }
</script>

<style lang="scss" scoped>
  img {
    max-height: 28px;
  }
  span
  {
    white-space: pre;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogNoMoreSpace.vue